import { getDataSimple } from "../helpers/apiHelper";
const API_COUNTRIES = "/countries";
const API_ALL_COUNTRIES = "/countries/all";

/**
 * fetch active countries
 */
export const fetchCountries = (): any => {
  const url = API_COUNTRIES;
  return getDataSimple(url);
};

/**
 * fetch all countries
 */
export const fetchAllCountries = (): any => {
  const url = API_ALL_COUNTRIES;
  return getDataSimple(url);
};
